import { useTranslation } from 'react-i18next';
import { Grid, Paper } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useState, useCallback, useEffect } from 'react';
import { DistrictDataGrid } from '../components/districtDataGrid';

export const DistrictListPage = () => {
  const [, setLoading] = useState(false);
  // const [searchString, setSearchString] = useState<string>('');
  // const [tempSearchString, setTempSearchString] = useState<string>('');
  // const [association, setAssociation] = useState<Association>();
  // const [district, setDistrict] = useState<District>();
  // const [status, setStatus] = useState<number[]>([UserStatusEnum.Active]);

  const { t } = useTranslation(['district']);

  const loadingCallback = useCallback((isLoading: boolean) => {
    setLoading(isLoading);
  }, []);

  useEffect(() => {
    // if (tempSearchString === '') {
    //   setSearchString('');
    // }
    // if (tempSearchString.length >= 2) {
    //   setSearchString(tempSearchString);
    // } else {
    //   setSearchString('');
    // }
  }); // ,  [tempSearchString]);

  return (
    <>
      <GridWrapper>
        <Grid item xs={12}>
          <MainContentHeader title={t('district:listDistrictHeader')} />
        </Grid>
        <Grid item xs={12} sx={{ mb: 0 }} />
      </GridWrapper>
      <GridWrapper>
        <Grid item xs={12}>
          <Paper>
            {/* <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  p: 2,
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <SearchField onSearch={(newSearchString) => setTempSearchString(newSearchString)} />
              </Box>
              <Box
                sx={{
                  p: 2,
                  display: 'flex',
                  alignItems: 'center',
                  '& .MuiInputLabel-formControl': {
                    backgroundColor: 'white',
                    px: '5px',
                  },
                }}
              >
                <Divider orientation='vertical' flexItem sx={{ mx: 2, my: -2 }} />
                <AssociationAndDistrictSelect
                  association={association}
                  district={district}
                  associationCallback={(val) => setAssociation(val || undefined)}
                  districtCallback={(val) => setDistrict(val || undefined)}
                />
              </Box>
            </Box>
            <Divider />
            <UserTabs disableAll={loading} status={status} callback={(val) => setStatus(val)} />
            <Divider /> */}
            {/* {status.length > 0 && ( */}
            <DistrictDataGrid
              loadingCallback={loadingCallback}
              // searchString={searchString}
              // associationId={association?.countyAss_id.toString()}
              // districtId={district?.countyAss_id.toString()}
              // status={status}
            />
            {/* )} */}
          </Paper>
        </Grid>
      </GridWrapper>
    </>
  );
};
